import { useFields } from "../../../../api/useFields";
import { findField } from "../../../../utils/findField";
import { getChipColor } from "../../../../components/chips/CustomChip";
import { FormatedField } from "../../../../types/fields.types";

const FALLBACK_STATUS_COLOR = "#9e9e9e";

export const useSessionStatusField = () => {
	const { formatedFields } = useFields("sessions");
	const statusField = findField(formatedFields ?? [], "status");
	return statusField;
};

export const getSessionStatusColor = (statusField: FormatedField | undefined, statusValue: string) => {
	const color = (statusField ? getChipColor(statusField, statusValue)?.background : undefined) ?? FALLBACK_STATUS_COLOR;
	return color;
};

export const useSessionStatusColor = (statusValue: string) => {
	const statusField = useSessionStatusField();
	const color = getSessionStatusColor(statusField, statusValue);
	return color;
};
